import BodyHeader from "@app/shared/components/BodyHeader/index.tsx";
import { usePageviewTrack } from "@app/shared/planhat/index.ts";
import { FlexCol } from "@design-system/Layout/Flex/index.tsx";
import { PageContainer } from "@design-system/Layout/PageContainer";
import { type FC } from "react";
import { useTranslation } from "react-i18next";
import { AvailableCategories } from "./components/AvailableCategories/index.tsx";
import CreateFrameworkProjectModal from "./components/CreateFrameworkProjectModal/index.tsx";
import { RecentProjects } from "./components/RecentProjects/index.tsx";
import "./i18n";

export const Frameworks: FC = () => {
    const { t } = useTranslation("Frameworks");

    usePageviewTrack("pageview_frameworks");
    return (
        <PageContainer>
            <BodyHeader
                title={t("title")}
                subTitle={t("subtitle")}
                action={<CreateFrameworkProjectModal />}
            />
            <FlexCol gap="7" p="4">
                <RecentProjects />
                <AvailableCategories />
            </FlexCol>
        </PageContainer>
    );
};
